import { DefaultError, useQuery } from '@tanstack/react-query';
import { ILightListItem } from 'services/types';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ISalesChannelProvider } from './types';

export const useGetSalesChannelsLightList = () => {
  const { responseHandler } = useResponseHandler();

  return useQuery<ILightListItem[], DefaultError>({
    queryKey: ['admin-sales-channel-light-list'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: 'SalesChannel/LightList',
      });

      return responseHandler(response, {
        groupName: 'useGetSalesChannelsLightList',
      });
    },
  });
};

export const useGetSalesChannelProviders = (
  salesChannelId: string | undefined,
  magellanAccountId?: string,
  enabled = true
) => {
  const { responseHandler } = useResponseHandler();

  return useQuery<ISalesChannelProvider[], DefaultError>({
    queryKey: [
      'admin-sales-channel-providers',
      salesChannelId,
      magellanAccountId,
    ],
    enabled: enabled && !!salesChannelId,
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: 'SalesChannel/Providers',
        params: {
          SalesChannelId: salesChannelId,
          ...(magellanAccountId ? { magellanAccountId } : {}),
        },
      });

      return responseHandler(response, {
        groupName: 'useGetSalesChannelProviders',
      });
    },
  });
};
